export default class EquipmentDto {
    constructor(obj) {
        this.equipmentId = obj.equipmentId
        this.id = obj.equipmentId
        this.equipmentType = obj.equipmentType
        this.materielType = obj.equipmentType
        this.centralIntegrated = obj.centralIntegrated
        this.sensorIntegrated = obj.sensorIntegrated
        this.simIntegrated = obj.simIntegrated
        this.telecomIntegrated = obj.telecomIntegrated
        this.powerSupplyIntegrated = obj.powerSupplyIntegrated
        this.variousMaterielIntegrated = obj.variousMaterielIntegrated
        this.antennaIntegrated = obj.antennaIntegrated
        this.comment = obj.comment
        this.purchaseDate = obj.purchaseDate
        this.warrantyTime = obj.warrantyTime
        this.manufactureDate = obj.manufactureDate
        this.providerId = obj.providerId
        this.serialNumber = obj.serialNumber
        this.reference = obj.reference
        this.administrator = obj.administrator
        this.updateDate = obj.updateDate
        this.updateLogin = obj.updateLogin
        this.codeNetwork = obj.codeNetwork
        this.networkCode = obj.networkCode
        this.supplyDuration = obj.supplyDuration
        this.manufacturerId = obj.manufacturerId
        this.jobexecutionid = obj.jobexecutionid
    }
}
